/**
 * @desc 分页
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.ApiInfoResponseDto>
>;
export function request(params: API.appCenter.api.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/api/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
